const Logger = () => next => action => {
    let result = next(action)
    return result
  }
  
  export default Logger